if (!customElements.get('copy-coupon-grid')) {
    class CopyCouponGrid extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.addEventListeners();
        }

        addEventListeners() {
            const buttons = this.querySelectorAll('.copy-coupon-grid__item__right__button');
            buttons.forEach(button => {
                button.addEventListener('click', (event) => this.handleButtonClick(event));
            });
        }

        handleButtonClick(event) {
            const button = event.currentTarget;
            const couponCode = button.getAttribute('data-coupon');
            const label = button.getAttribute('data-label');

            // 复制 couponCode
            navigator.clipboard.writeText(couponCode);

            // 替换span内容为 Copied!
            const span = button.querySelector('span');
            span.textContent = 'Copied!';

            // 2秒后恢复原内容和样式
            setTimeout(() => {
                span.textContent = label;
            }, 2000);
        }
    }

    customElements.define('copy-coupon-grid', CopyCouponGrid);
}
